
import { ExternalLink, MessageSquare, Link } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { HoverCard, HoverCardContent, HoverCardTrigger } from "@/components/ui/hover-card";

const TermedCard = () => {
  return (
    <Card className="w-full max-w-md glass-panel animate-float relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-neon-red/10 via-transparent to-transparent pointer-events-none" />
      
      <CardHeader className="space-y-1">
        <CardTitle className="text-2xl text-center neon-text animate-pulse-stronger">
          Account Terminated
        </CardTitle>
        <CardDescription className="text-center text-gray-400">
          My Discord account has been terminated
        </CardDescription>
      </CardHeader>

      <CardContent className="space-y-6">
        <div className="space-y-4 text-center">
          <p className="text-lg text-gray-200">
            Please add me on my new account:
          </p>
          <div className="flex items-center justify-center space-x-2">
            <MessageSquare className="h-5 w-5 text-neon-red" />
            <span className="text-xl font-hacker text-neon-red animate-pulse">
              deposals
            </span>
          </div>
        </div>

        <div className="flex flex-col gap-3">
          <Button 
            variant="outline" 
            className="w-full neon-border hover:bg-neon-red/20"
            onClick={() => navigator.clipboard.writeText('deposals')}
          >
            <Link className="mr-2 h-4 w-4" />
            Copy Username
          </Button>
          
          <Button
            variant="outline"
            className="w-full neon-border hover:bg-neon-red/20"
            onClick={() => window.open('https://discord.gg/zentirog', '_blank')}
          >
            <ExternalLink className="mr-2 h-4 w-4" />
            Join Discord Server
          </Button>
        </div>

        <div className="text-center relative z-50">
          <HoverCard>
            <HoverCardTrigger asChild>
              <button className="text-[10px] text-gray-500 hover:text-gray-400 cursor-help bg-transparent border-none p-0">
                Akira? Click here
              </button>
            </HoverCardTrigger>
            <HoverCardContent 
              className="w-80 fixed z-[100] bg-dark-panel backdrop-blur-md border border-neon-red rounded-md shadow-neon"
              side="bottom"
              align="center"
              sideOffset={20}
            >
              <div className="flex justify-between space-x-4">
                <div className="space-y-1">
                  <h4 className="text-sm font-semibold text-neon-red">Hey Akira!</h4>
                  <p className="text-sm text-gray-200">
                    Please add me to my new account. You know it's me! 🙂
                  </p>
                </div>
              </div>
            </HoverCardContent>
          </HoverCard>
        </div>
      </CardContent>
    </Card>
  );
};

export default TermedCard;

